// src/hooks/useMinDuration.ts
// Retarde le passage de `true` à `false` d'un booléen pour garantir un affichage minimum —
// utilisé pour tout usage de <LoadingScreen/> (cf. src/components/LoadingScreen.tsx) afin
// d'éviter un flash trop bref pour les opérations qui se terminent quasi instantanément.

import { useEffect, useRef, useState } from "react";

const DEFAULT_MIN_MS = 800;

export function useMinDuration(active: boolean, minMs: number = DEFAULT_MIN_MS): boolean {
  const [shown, setShown] = useState(active);
  const shownAtRef = useRef<number | null>(active ? Date.now() : null);

  useEffect(() => {
    if (active) {
      shownAtRef.current = Date.now();
      setShown(true);
      return;
    }
    if (!shown) return; // déjà masqué, rien à retarder
    const elapsed = shownAtRef.current != null ? Date.now() - shownAtRef.current : minMs;
    const remaining = Math.max(0, minMs - elapsed);
    const t = setTimeout(() => setShown(false), remaining);
    return () => clearTimeout(t);
  }, [active, minMs, shown]);

  return shown;
}
